
export enum EnvironmentType {
    development = "development",
    staging = "staging",
    production = "production"
}

